import CookieManager from './app/CookieManager'
import AsyncSectionLoader from './app/asyncSectionLoader'
import AsyncContentLoader from './app/asyncContentLoader'
import Wishlist from './app/Wishlist'
import Cart from './app/Cart'
import Info from './app/Info'
import SearchAutocompletion from './app/searchAutocompletion'
import Contact from './app/contact'
import Fluidpage from './app/fluidpage'
import Unicorn from './app/unicorn'
import Filter from './app/filter'
import Custombone from './app/custombone'
import ScrollHandler from './app/ScrollHandler'
import AdminSearch from './app/adminSearch'
import EteileFinder from './app/eteilefinder'
import Order from './app/Order'
import Price from './app/Price'
import Analytics from './app/Analytics';
import gtm from './app/gtm.js'
import ZipCode from './app/zipcode';
import ExpressPlusImageUpload from './app/epimageupload'
import Shop from './app/shop';
import IconLoader from './app/iconLoader';
import VariantAdmin from './app/VariantAdmin';
import VarianteAdmin from './app/VarianteAdmin';
import MarketSearch from './app/MarketSearch';
import Userlike from './app/userlike';
import Covid from './app/covid';
import Form from './app/Form';
import Payment from './app/Payment';
import Elements from './app/Elements';

class App {
	/**
	 * Instantiate all child controller when the page is loaded and the DOM is available
	 */
	load() {
		this.gtm = new gtm(this);
		this.info = new Info(this);
		this.iconLoader = new IconLoader(this);
		this.asyncSection = new AsyncSectionLoader(this);
		this.asyncContent = new AsyncContentLoader(this);
		this.analytics = new Analytics(this);
		this.wishlist = new Wishlist(this);
		this.cart = new Cart(this);
		this.searchAutocompletion = new SearchAutocompletion(this);
		this.contact = new Contact(this);
		this.fluidpage = new Fluidpage(this);
		this.unicorn = new Unicorn(this);
		this.filter = new Filter(this);
		this.custombone = new Custombone(this);
		this.scrollhandler = new ScrollHandler(this);
		this.adminSearch = new AdminSearch(this);
		this.eteileFinder = new EteileFinder(this);
		this.payment = new Payment(this);
		this.order = new Order(this);
		this.price = new Price(this);
		this.zipcode = new ZipCode(this);
		this.epimageuload = new ExpressPlusImageUpload(this);
		// this.shop = new Shop(this);
		this.variantadmin = new VariantAdmin(this);
		this.varianteadmin = new VarianteAdmin(this);
		this.marketSearch = new MarketSearch(this);
		this.covid = new Covid(this);
		this.form = new Form(this);
		this.elements = new Elements(this);
		this.Userlike = new Userlike(this)
		this.cookieManager = new CookieManager(); // load at end, so we can bind events before
	}
}

// global variables
const app = window.top['app'] = new App();
const timeStart = performance.now();

// Main handler
$(document).ready(function () {
	app.load();

	if (app.info.isDebug) {
		const timeEnd = performance.now();
		console.debug('Loaded App in %s milliseconds.', timeEnd - timeStart);
	}
});
